<template>
  <span
    v-tooltip="{
      content: message,
      html: true,
      skidding: 18,
      distance: -7,
      placement: 'bottom-start',
      theme: state !== 'pending' ? 'large-tooltip' : 'tooltip',
    }"
    class="review-status"
    :class="state"
  >
    <i
      :class="iconClass"
    />
  </span>
</template>

<script>
export default {
  props: {
    state: {
      type: String,
      default: 'pending',
    },
    message: {
      type: String,
      default: 'Pending review, this may take a few moments',
    },
  },
  computed: {
    iconClass() {
      const icons = {
        'good': 'fa fa-check',
        'bad': 'fa fa-question',
        'pending': 'fa fa-spinner fa-spin',
        'unreviewed': 'far fa-hourglass',
      };

      return icons[this.state];
    },
  }
}
</script>

<style lang="scss" scoped>
.review-status {
  display: inline-block;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  text-align: center;

  &.good {
    color: #fff;
    background: #31D0AA;
  }

  &.bad {
    color: #fff;
    background: #FFD673;
  }

  &.pending {
    color: #5A3CD7;
    background: #F0E9FF;
  }

  &.unreviewed {
    color: #fff;
    background: #6ECADA;
  }

  i {
    line-height: 32px;
  }
}
</style>
